import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntGetriebe: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, t: 'Manuell', hidden: true },
    { i: 2, t: 'Automatik', hidden: true },
    { i: 4, t: 'Halb-Automatik', hidden: true },
    { i: 16, t: 'Manuell' },
    { i: 19, t: 'Manuell 3-Gang' },
    { i: 20, t: 'Manuell 4-Gang' },
    { i: 21, t: 'Manuell 5-Gang' },
    { i: 22, t: 'Manuell 6-Gang' },
    { i: 23, t: 'Manuell 7-Gang' },
    { i: 32, t: 'Automatik' },
    { i: 33, t: 'Automatik 1-Gang' },
    { i: 35, t: 'Automatik 3-Gang' },
    { i: 36, t: 'Automatik 4-Gang' },
    { i: 37, t: 'Automatik 5-Gang' },
    { i: 38, t: 'Automatik 6-Gang' },
    { i: 39, t: 'Automatik 7-Gang' },
    { i: 40, t: 'Automatik 8-Gang' },
    { i: 41, t: 'Automatik 9-Gang' },
    { i: 42, t: 'Automatik 10-Gang' },
    { i: 64, t: 'Halb-Automatik' },
];
export default sIntGetriebe;
